<template>
  <div class="profile-dialog">
    <v-dialog
      v-show="profileDialog"
      v-model="profileDialog"
      persistent
      max-width="600px"
    >
      <v-card
        class="mx-auto pl-4"
        min-height="370px"
        max-width="700px"
        v-if="profile"
      >
        <v-row class="pt-10 pl-10">
          <v-col
            cols="4"
            class="d-flex justify-space-between flex-column"
            style="height: 300px"
          >
            <v-avatar color="indigo" size="100">
              <v-icon dark size="70">mdi-account</v-icon>
            </v-avatar>
            <v-col class="d-flex align-end pl-0 pb-4">
              <v-btn color="error" @click="setProfileDialog(false)">
                Close
              </v-btn>
            </v-col>
          </v-col>
          <v-col cols="8">
            <v-row>
              <v-col class="display-1">
                {{ profile.UserName || 'No Name' }}
              </v-col>
            </v-row>
            <v-divider class="mt-3 mb-12 mr-6"></v-divider>
            <v-row>
              <v-col
                cols="4"
                class="d-flex align-center grey--text text--darken-1"
              >
                <v-icon size="20" class="pr-2">mdi-account-group</v-icon>
                <span>
                  Affiliation
                </span>
              </v-col>
              <v-col>
                <span class="blue-grey--text text--lighten-1">
                  {{ profile.Affiliation || 'No Data' }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="4"
                class="d-flex align-center grey--text text--darken-1"
              >
                <v-icon size="20" class="pr-2">mdi-map-marker</v-icon>
                <span>
                  Country
                </span>
              </v-col>
              <v-col>
                <span class="blue-grey--text text--lighten-1">
                  {{ profile.Country || 'No Data' }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="4"
                class="d-flex align-center grey--text text--darken-1"
              >
                <v-icon size="20" class="pr-2">mdi-web</v-icon>
                <span>
                  Website
                </span>
              </v-col>
              <v-col>
                <template v-if="is_empty(profile.Website)">
                  <span class="blue-grey--text text--lighten-1">
                    No Data
                  </span>
                </template>
                <template v-else>
                  <a
                    :href="profile.Website"
                    class="blue-grey--text text--lighten-1"
                    target="_blank"
                  >
                    {{ profile.Website }}
                  </a>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  title: 'profile',
  components: {},
  props: {
    profileDialog: {
      type: Boolean,
      default: false,
    },
    profile: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    setProfileDialog(show) {
      this.$emit('setProfileDialog', show)
    },
  },
}
</script>
